//function common header crm links
// Helper function to check user permissions
const hasPermission = (currentUserRole, moduleaccess, moduleName) => {
  return (
    currentUserRole === "ADMIN" ||
    currentUserRole === "SUPER_ADMIN" ||
    moduleaccess.includes(moduleName)
  );
};

const commonHeaderLinkLists = (t) => {
  // loggedin user details to get the role
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // get the role and allow for admin or superadmin
  const currentUserRole = userInfo.role ? userInfo.role.slug : "USER";

  // get module access for roles other than admin and superadmin
  const moduleaccess = localStorage.getItem("moduleaccess");

  //console.log('currentUserRole', currentUserRole);

  // console.log("moduleaccess", moduleaccess);

  const headerTabs = [];

  const tabsConfig = [
    {
      module: "MOD_DOCTOR_MANAGEMENT",
      title: t("Doctor"),
      link: "/admin/clinicalmanagement/doctors",
    },
    {
      module: "MOD_PATIENT_MANAGEMENT",
      title: t("Patient"),
      link: "/admin/clinicalmanagement/patients",
    },
    {
      module: "MOD_MEDICINE_MANAGEMENT",
      title: t("Medicine"),
      link: "/admin/clinicalmanagement/medicines",
    },
    {
      module: "MOD_TREATMENT_MANAGEMENT",
      title: t("Treatment"),
      link: "/admin/clinicalmanagement/treatments",
    },
    {
      module: "MOD_APPOINTMENT_MANAGEMENT",
      title: t("Appointment"),
      link: "/admin/clinicalmanagement/appointments",
    },
    {
      module: "MOD_BILLABLE_ACTIVITY_MANAGEMENT",
      title: t("Billable Activity"),
      link: "/admin/clinicalmanagement/billableactivities",
    },
    {
      module: "MOD_HEALTH_CENTER_MANAGEMENT",
      title: t("Health Center"),
      link: "/admin/clinicalmanagement/healthcenters",
    },
    {
      module: "MOD_VACCINATION_MANAGEMENT",
      title: t("Vaccination"),
      link: "/admin/clinicalmanagement/vaccination",
    },
    {
      module: "MOD_PRESCRIPTION_MANAGEMENT",
      title: t("Prescription"),
      link: "/admin/clinicalmanagement/prescriptions",
    },
    {
      module: "MOD_INVENTORY_MANAGEMENT",
      title: t("Inventory"),
      link: "/admin/clinicalmanagement/inventory",
    },
  ];

  tabsConfig.forEach((tabConfig) => {
    if (hasPermission(currentUserRole, moduleaccess, tabConfig.module)) {
      headerTabs.push({ title: tabConfig.title, link: tabConfig.link });
    }
  });

  return headerTabs;
};

export { commonHeaderLinkLists };
